<template>
  <div>
    <downtime-alert
      :message="downtimeObj?.GIDM?.displayMsg"
      v-if="
        downtimeObj?.GIDM?.downtimeStarted && downtimeObj?.GIDM?.showWarning
      "
    ></downtime-alert>
    <detail-card
      :heading="isDesktopChannel ? props.MO.heading : props.heading"
      :subheading="isDesktopChannel ? props.MO.subheading : props.subheading"
      :imageType="!isDesktopChannel ? props.imageType : null"
      :isLoading="isFetching"
      :headingClass="isDesktopChannel ? 'leo-text-left' : 'leo-text-center'"
    >
    <leo-card-note
      v-if="isCredentialInvalid"
      color="secondary"
      bgColor="light-error"
      style="border: 1px solid #EB0033"
    >
      <template v-slot:icon>
        <leo-icon class="leo-mr-xs" color="error" size="lg" type="warning"></leo-icon>
      </template>
      <template v-slot:title>
        <div class="leo-mb-xs">
          {{ props.MO.invalidCredentialHeading }}
        </div>
      </template>
      <template v-slot:description>
        <div class="leo-text-md">
          {{ props.MO.invalidCredentialLabel }}
        </div>
      </template>
    </leo-card-note>
      <leo-form ref="form" @validate="validated = $event">
        <form
          @submit.prevent="submit"
          autocorrect="off"
          role="form"
          spellcheck="false"
          autocapitalize="off"
          autocomplete="new-password"
        >
          <div class="leo-flex leo-flex-col leo-gap-md">
            <username-input
              :isError="isErrorUsername"
              :isDisabled="isDisabledUserName || disableInput"
              :placeholderLabel="placeholderText"
              autocomplete="webauthn"
              :isPlaceholderRequired="!isDesktopChannel"
              @onBlur="validateSignInFormat($v.username)"
            ></username-input>
            <leo-input
              v-if="isamMemberId !== ''"
              :disabled="true"
              id="fake-user-input"
              style="height: 0px; opacity: 0; padding: 0px; margin-top: -1rem"
            >
            </leo-input>
            <PasswordInput
              :isError="isErrorPassword"
              @onBlur="validateSignInFormat($v.password)"
            ></PasswordInput>
            <div v-if="!isDisabledUserName">
              <a
                @click="redirectToForgetPassword"
                :class="['leo-text-primary', 'leo-link', 'leo-cursor-pointer', !isDesktopChannel ? 'leo-subheading' : '']"
              >
                {{ isDesktopChannel ? props.MO.resetPasswordLabel : props.forgotPasswordLabel }}
              </a>
            </div>
          </div>
          <div :class="['leo--flex', 'leo-flex-col', isDesktopChannel ? 'leo-pt-7xl' : '']">
            <div>
              <leo-button
                type="submit"
                primary
                block
                :class="isDesktopChannel ? 'leo-mr-md' : 'leo-my-xl'"
                id="btnSubmit"
                :disabled="
                  downtimeObj?.GIDM?.disableButton ||
                  (!this.$v.username.$model || this.$__isValidationError(this.$v.username)) ||
                  (!this.$v.password.$model || this.$__isValidationError(this.$v.password))
                "
              >
                {{ isDesktopChannel ? props.MO.buttonLabel : props.buttonLabel }}
              </leo-button>
            </div>
            <div v-if="!isDisabledUserName" :class="['leo-flex leo-justify-center leo-text-center', isDesktopChannel ? 'leo-mt-xl' : '']">
              <span>{{ props.dontHaveLabel }}</span>
              <a
                href="javascript:void(0);"
                @click="isDesktopChannel ? openContactUs() : redirectToSignup()"
                :class="[ 'leo-text-primary leo-link leo-cursor-pointer', isDesktopChannel ? 'leo-ml-2xs' : 'leo-subheading leo-ml-xs' ]"
              >
                {{ isDesktopChannel ? props.MO.contactUsLabel : props.signupLinkLabel }}
              </a>
            </div>
          </div>
        </form>
      </leo-form>
    </detail-card>
    <contact-us
      :isShow="isContactUsShow"
      v-on:on-close="isContactUsShow = false"
    ></contact-us>
  </div>
</template>
<script>
import PasswordInput from "@/components/base/password-input/PasswordInput";
import ContactUs from "@/components/shared/modal/ContactUs";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { required, helpers } from "vuelidate/lib/validators";
const customValidator = helpers.regex(
  "customValidator",
  /[\w-!$%^&*()_+|~=`{}[\]:";'<>?/,.]/
);
const customEmailValidator = helpers.regex("email", /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)
import { ValidationErrorClass, CommonClass } from "@/mixins";
import * as e2eejslib from "@/helpers/e2eejslib";
import sessionStorageUtils from "@/utils/session-storage";
import { ERROR_CODES } from "@/utils/constants";
import { VueLeoButton } from "@greateasternlife/leo-button";
import { VueLeoCardNote } from "@greateasternlife/leo-card-note";
import { VueLeoForm } from "@greateasternlife/leo-form";
import UsernameInput from "@/components/base/username-input/UsernameInput";
import DetailCard from "@/components/base/detail-card/DetailCard";
import axios from "axios";
// import apiConstants from "@/utils/api-constants";
import { clearMemberIdRequestID } from "@/router";
import { util } from "@/helpers";
import {
  base64URLDecode,
  base64URLEncode,
  setFidoUser,
  detectMob,
} from "@/utils/fido-services";
import DowntimeAlert from "../base/alert/DowntimeAlert.vue";
export default {
  name: "Auth",
  components: {
    "contact-us": ContactUs,
    PasswordInput,
    "leo-button": VueLeoButton,
    "leo-card-note": VueLeoCardNote,
    "leo-form": VueLeoForm,
    "username-input": UsernameInput,
    "detail-card": DetailCard,
    "downtime-alert": DowntimeAlert,
  },
  mixins: [ValidationErrorClass, CommonClass],
  provide() {
    return {
      $v: this.$v,
    };
  },
  inject: ["downtimeObj"],
  data() {
    return {
      username: "",
      password: "",
      isamRequestID: "",
      isamMemberId: "",
      isamAcrFlag: "",
      isDesktopChannel: false,
      isContactUsShow: false,
      defaultCountry: "",
      props: this.$getConstant.signInProp,
      urlPrefix: this.$getConstant.urlContants,
      errMessage: this.$getConstant?.messages?.errorMessage,
      placeholderText: this.$getConstant?.signInProp?.emailAddressPlaceholder,
      disableInput: false,
      disablePasskeys: detectMob()
        ? process.env.VUE_APP_DISABLE_FIDO_MOBILE
        : process.env.VUE_APP_DISABLE_FIDO_WEB,
      isErrorUsername: false,
      isErrorPassword: false,
      isCredentialInvalid: false,
      loginType: "password",
    };
  },
  async mounted() {
    this.isDesktopChannel = this.$__checkIsDesktopChannel(sessionStorageUtils.getItem("ChannelId"));
    // const FIDO_URL = apiConstants.FIDO_ISAM_API;
    this.defaultCountry = sessionStorageUtils.getItem("appCountry");
    sessionStorageUtils.setItem("eventDetails.category", "MID - login");
    sessionStorage.setItem("journeyType", "MID login");
    sessionStorage.setItem("content-category-name", "MID-login");
    await this.handleISAMRequest();
    const HOSTNAME = window.location.hostname;
    const FIDO_URL = (function getAuthPolicyURL() {
      var authURL = "https://" + HOSTNAME + "/mga/sps/apiauthsvc/policy/";
      if (HOSTNAME.indexOf("sso-sg") >= 0) {
        authURL = authURL + "gelsgfidopasskey";
      }
      if (HOSTNAME.indexOf("sso-my") >= 0) {
        authURL = authURL + "gelmyfidopasskey";
      }
      return authURL;
    })();

    if (this.disablePasskeys === "false" && this.isamMemberId === "") {
      try {
        if (navigator.credentials.conditionalMediationSupported) {
          const resp = await axios.post(FIDO_URL, {
            policyaction: "GET_FIDO_CHALLENGE",
          });
          this.passKeyLoginSignChallege(resp.data, "autofill");
          // eslint-disable-next-line no-undef
        } else if (
          // eslint-disable-next-line no-undef
          PublicKeyCredential.isConditionalMediationAvailable != null
        ) {
          const result =
            // eslint-disable-next-line no-undef
            await PublicKeyCredential.isConditionalMediationAvailable();
          if (result) {
            const resp = await axios.post(FIDO_URL, {
              policyaction: "GET_FIDO_CHALLENGE",
            });
            this.passKeyLoginSignChallege(resp.data, "autofill");
          }
        } else {
          console.log(
            "PublicKeyCredential.isConditionalMediationAvailable is not defined "
          );
        }
      } catch (e) {
        console.log("FIDO error 1", e);
      }
    }
    sessionStorageUtils.deleteItem("isUsenamePass");
  },
  beforeUnmount() {
    this.disableInput = false;
  },
  methods: {
    ...mapActions("user", [
      "loginFlow",
      "getRandomPublicKeyForEncryption",
      "setMemberId",
      "fetchIsamMemberId",
    ]),
    ...mapMutations({ showAlert: "alert/SHOW_ALERT" }),

    validateSignInFormat(data) {
      if (data == this.$v.username) {
        this.isErrorUsername = this.$__isValidationError(data);
      } else if (data == this.$v.password) {
        this.isErrorPassword = this.$__isValidationError(data);
      }
    },

    redirectToSignup() {
      const appId = sessionStorageUtils.getItem("appId");
      if (appId && appId !== "Unknown") {
        this.$router.push({
          path: `${this.urlPrefix.registerUrl}`,
          query: { app_id: appId },
        });
      } else {
        this.$router.push(`${this.urlPrefix.registerUrl}`);
      }
    },
    async passKeyLoginSignChallege(assertResponse, loginType) {
      const FIDO_URL =
        window.location.protocol +
        "//" +
        window.location.hostname +
        assertResponse.location;
      var publicKey = {
        rpId: assertResponse.rpId,
        timeout: assertResponse.timeout,
        challenge: base64URLDecode(assertResponse.challenge),
        userVerification: "required",
        extensions: assertResponse.extensions,
        allowCredentials: assertResponse.allowCredentials,
      };
      publicKey.allowCredentials.forEach(function (listItem) {
        listItem.id = base64URLDecode(listItem.id);
      });
      let payload = {
        publicKey: publicKey,
      };
      if (loginType && loginType == "autofill") {
        this.abortController = new AbortController();
        let abortSignal = this.abortController.signal;
        payload.mediation = "conditional";
        payload.signal = abortSignal;
      }
      try {
        const assertion = await navigator.credentials.get(payload);
        this.abortController = null;

        var assertionObj = {};
        assertionObj.id = assertion.id;
        assertionObj.rawId = base64URLEncode(assertion.rawId);
        sessionStorageUtils.setItem("activeRawId", assertionObj.rawId);
        assertionObj.clientDataJSON = base64URLEncode(
          assertion.response.clientDataJSON
        );
        assertionObj.authenticatorData = base64URLEncode(
          assertion.response.authenticatorData
        );
        assertionObj.signature = base64URLEncode(assertion.response.signature);
        assertionObj.userHandle = base64URLEncode(
          assertion.response.userHandle
        );
        assertionObj.type = assertion.type;
        if (assertion.getClientExtensionResults())
          assertionObj.getClientExtensionResults = JSON.stringify(
            assertion.getClientExtensionResults()
          );
        if (assertion.authenticatorAttachment)
          assertionObj.authenticatorAttachment =
            assertion.authenticatorAttachment;

        assertionObj.policyaction = "VERIFY_FIDO_CHALLENGE";
        assertionObj.operation = "returnToDecision";
        try {
          const response = await axios.post(FIDO_URL, assertionObj);

          var fidoUser = {};
          fidoUser.username = response.data.username;
          fidoUser.rawId = response.data.credentialId;
          fidoUser.skip = false;
          if (response.data.username && response.data.credentialId) {
            setFidoUser(fidoUser);
            // clear off email fields when using passkey
            // only pre login
            if (this.isamMemberId === "") {
              this.$v.username.$model = "";
              this.isErrorUsername = false;
            }
          }
          // BFF Calling
          const step1Response = await this.loginFlow(
            this.fidoLoginPayload(response.data.stateId)
          );
          if (this.getRequestStatus === 2) {
            this.setMemberId(this.$v.username.$model);
            if (this.getData?.errCode === ERROR_CODES.MIDERR_007) {
              this.$router.push("/error/non-policy-holder");
            } else if (this.getData?.errCode === ERROR_CODES.MIDERR_020) {
              // this.$router.replace({
              //   path: `${this.urlPrefix.loginUrl}/error`,
              //   query: { errCode: this.getData?.errCode },
              // });
              this.$router.replace(
                `${this.urlPrefix.loginUrl}/my-info?errCode=${this.getData?.errCode}&optionAllowed=true`
              );
            } else if (this.getData?.errCode === ERROR_CODES.MIDERR_038) {
              this.$router.replace({
                path: `${this.urlPrefix.loginUrl}/error`,
                query: { errCode: this.getData?.errCode },
              });
            } else if (this.getData?.errCode === ERROR_CODES.MIDERR_001) {
              this.isCredentialInvalid = true;
            } else if (this.getData?.errCode === ERROR_CODES.MIDERR_015) {
              const errDesc = util.getUiErrorByCode(this.getData?.errCode);
              this.showAlert({
                type: "error",
                message: errDesc,
              });
            }
          }
          if (this.getRequestStatus === 1 && step1Response) {
            sessionStorageUtils.setItem("requestID", step1Response?.requestID);
            this.setMemberId(this.$v.username.$model);
            if (
              step1Response?.successFlag &&
              step1Response?.nextStep === "SN_TRIGGER_SMS_OTP"
            ) {
              window.dataLayerPush({
                event: "attempt_login",
                "eventDetails.category": 'MID - login',
                "eventDetails.label": "continue - successful biometrics EB login",
                journeyType: "FO EB biometric login - auto/manual/email/passkey",
                appId: "FO EB Biometric login",
              });
              // Trigger SMS OTP flow (ISAM Redirect flow)
              const step2Response = await this.triggerSmsOTP();
              if (
                step2Response?.successFlag &&
                step2Response?.nextStep === "SN_VERIFY_SMS_OTP"
              ) {
                // ISAM level2 flow (Redirect to otp page)
                this.$router.push(
                  `${this.urlPrefix.loginUrl}/mobile-otp-verification`
                );
              } else if (!step2Response?.successFlag) {
                if (
                  step2Response?.errCode === ERROR_CODES.MIDERR_026 ||
                  step2Response?.errCode === ERROR_CODES.MIDERR_020
                ) {
                  this.$router.replace(
                    `${this.urlPrefix.loginUrl}/my-info?errCode=${step2Response?.errCode}&optionAllowed=true`
                  );
                } else if (step2Response?.errCode === ERROR_CODES.MIDERR_038) {
                  this.$router.replace({
                    path: `${this.urlPrefix.loginUrl}/error`,
                    query: { errCode: step2Response?.errCode },
                  });
                } else if (this.getData?.errCode === ERROR_CODES.MIDERR_001) {
                  this.isCredentialInvalid = true;
                } else if (this.getData?.errCode === ERROR_CODES.MIDERR_015) {
                  const errDesc = util.getUiErrorByCode(this.getData?.errCode);
                  this.showAlert({
                    type: "error",
                    message: errDesc,
                  });
                }
              }
            } else if (
              step1Response?.successFlag &&
              step1Response?.nextStep === "SN_TRIGGER_EMAIL_OTP"
            ) {
              window.dataLayerPush({
                event: "attempt_login",
                "eventDetails.category": "MID - login",
                "eventDetails.label": "continue - successful biometrics EB login",
                journeyType: "FO EB biometric login - auto/manual/email/passkey",
                appId: "FO EB Biometric login",
              });
              // Trigger EMAIL OTP flow (ISAM Redirect flow)
              const step2Response = await this.triggerEmailOTP();
              if (
                step2Response?.successFlag &&
                step2Response?.nextStep === "SN_VERIFY_EMAIL_OTP"
              ) {
                // ISAM level2 flow (Redirect to otp page)
                this.$router.push(
                  `${this.urlPrefix.loginUrl}/email-otp-verification`
                );
              } else if (!step2Response?.successFlag) {
                if (
                  step2Response?.errCode === ERROR_CODES.MIDERR_026 ||
                  step2Response?.errCode === ERROR_CODES.MIDERR_020
                ) {
                  this.$router.replace(
                    `${this.urlPrefix.loginUrl}/my-info?errCode=${step2Response?.errCode}&optionAllowed=true`
                  );
                } else if (step2Response?.errCode === ERROR_CODES.MIDERR_038) {
                  this.$router.replace({
                    path: `${this.urlPrefix.loginUrl}/error`,
                    query: { errCode: step2Response?.errCode },
                  });
                } else if (this.getData?.errCode === ERROR_CODES.MIDERR_001) {
                  this.isCredentialInvalid = true;
                } else if (this.getData?.errCode === ERROR_CODES.MIDERR_015) {
                  const errDesc = util.getUiErrorByCode(this.getData?.errCode);
                  this.showAlert({
                    type: "error",
                    message: errDesc,
                  });
                }
              }
            } else if (
              step1Response?.successFlag &&
              step1Response?.nextStep === "SN_VIEW_PROFILE"
            ) {
              // default flow load user profile
              sessionStorageUtils.setItem("loggedIn", true);
              if (
                sessionStorage.getItem("redirectedFromViewSetting") === "true"
              ) {
                sessionStorage.removeItem("redirectedFromViewSetting");
                this.$router.push(`${this.urlPrefix.loginUrl}/device-info`);
              } else {
                this.$router.push(`${this.urlPrefix.loginUrl}/view-profile`);
              }
            } else if (
              step1Response?.successFlag &&
              step1Response?.nextStep === "" &&
              step1Response?.responseParam?.login === "success"
            ) {
              window.dataLayerPush({
                event: "attempt_login",
                "eventDetails.category": "MID - login",
                "eventDetails.label": "continue - successful biometrics EB login",
                journeyType: "FO EB biometric login - auto/manual/email/passkey",
                appId: "FO EB Biometric login",
              });
              const redirectUrl =
                step1Response?.responseParam &&
                step1Response?.responseParam?.redirectUrl;
              sessionStorageUtils.setItem("loggedIn", true);
              this.$__handleIsamResponse(redirectUrl);
            }

            // if (step1Response?.successFlag && this.$v.username.$model) {
            //   this.setGreatId(this.$v.username.$model);
            // }
          } else {
            //
          }
        } catch (e) {
          console.log("FIDO API error 2", e);
        }
      } catch (e) {
        console.log(
          "FIDO API error 3 navigator.credentials.get not available",
          e
        );
      }
    },
    redirectToForgetPassword() {
      // if (this.isamRequestID !== "") {
      //   this.$router.push({
      //     path: `${this.urlPrefix.loginUrl}/forgot-password`,
      //     query: { requestId: this.isamRequestID },
      //   });
      // } else {
      //   this.$router.push(`${this.urlPrefix.loginUrl}/forgot-password`);
      // }
      sessionStorage.setItem("journeyType", "MID forgot your password");
      sessionStorage.setItem("content-category-name", "Forget-password");
      this.$router.push(`${this.urlPrefix.loginUrl}/forgot-password`);
    },
    async handleISAMRequest() {
      this.isamRequestID = this.$__checkRequestIdISAM();
      if (this.isamRequestID) {
        sessionStorageUtils.setItem("requestID", this.isamRequestID);
      }

      /* eslint-disable */
      // const memberIdRequestID = document.cookie.replace(
      //   /(?:(?:^|.*;\s*)MEMBERID-REQUEST-ID\s*\=\s*([^;]*).*$)|^.*$/,
      //   "$1"
      // );
      // console.log("memberIdRequestID", memberIdRequestID);
      // if (memberIdRequestID) {
      //   this.isamRequestID = memberIdRequestID;
      //   sessionStorageUtils.setItem("requestID", memberIdRequestID);
      // }
      // if (this.$route.query?.requestId) {
      //   this.isamRequestID = this.$route.query?.requestId;
      //   sessionStorageUtils.setItem("requestID", this.isamRequestID);
      // }
      if (this.$route.query?.isam_acr_flag) {
        this.isamAcrFlag = atob(this.$route.query?.isam_acr_flag);
      }
      const requestID = sessionStorageUtils.getItem("requestID");
      if (requestID && this.isamAcrFlag) {
        const memberId = await this.fetchIsamMemberId(requestID);
        if (memberId) {
          this.isamMemberId = memberId;
          this.$v.username.$model = memberId;
        }
      }
      if (this.getExistingMemberId) {
        this.$v.username.$model = this.getExistingMemberId;
        this.disableInput = true;
      }
      // if (this.$route.query?.err_msg) {
      //   this.showTokenError(this.$route.query?.err_msg);
      // }
    },
    async submit() {
      this.$v.$touch();
      this.isCredentialInvalid= false
      if (!this.$v.$invalid && !this.isDesktopChannel) {
        // To get public key for password encryption
        await this.getRandomPublicKeyForEncryption(sessionStorageUtils.getItem("requestID"));
        const publicKeyData = this.getPublicKey;
        if (publicKeyData) {
          const publicKey = publicKeyData?.publicKey;
          //const random = publicKeyData?.random;
          const arr = publicKeyData?.random.split(":signature:");
          console.log("arr : " + arr);
          const random = arr[0];
          const signature = arr[1];
          console.log("random : " + random);
          console.log("signature : " + signature);
          //const encryptPwd = HSM.RsaEncrypt(
          //publicKey,
          //this.$v?.password?.$model,
          //random
          //);
          let encryptPwd = e2eejslib.EncryptSHA256Password(
            publicKey,
            this.$v?.password?.$model,
            random
          );
          console.log("encryptPwd : " + encryptPwd);
          encryptPwd = encryptPwd + "," + signature;
          console.log("encryptPwd : " + encryptPwd);

          const step1Response = await this.loginFlow(
            this.loginPayload(encryptPwd)
          );
          if (this.getRequestStatus === 2) {
            this.setMemberId(this.$v.username.$model);
            if (this.getData?.errCode === ERROR_CODES.MIDERR_007) {
              this.$router.push("/error/non-policy-holder");
            } else if (this.getData?.errCode === ERROR_CODES.MIDERR_020) {
              // this.$router.replace({
              //   path: `${this.urlPrefix.loginUrl}/error`,
              //   query: { errCode: this.getData?.errCode },
              // });
              this.$router.replace(
                `${this.urlPrefix.loginUrl}/my-info?errCode=${this.getData?.errCode}&optionAllowed=true`
              );
            } else if (this.getData?.errCode === ERROR_CODES.MIDERR_038) {
              this.$router.replace({
                path: `${this.urlPrefix.loginUrl}/error`,
                query: { errCode: this.getData?.errCode },
              });
            } else if (this.getData?.errCode === ERROR_CODES.MIDERR_001) {
              this.isCredentialInvalid = true;
            } else if (this.getData?.errCode === ERROR_CODES.MIDERR_015) {
              const errDesc = util.getUiErrorByCode(this.getData?.errCode);
              this.showAlert({
                type: "error",
                message: errDesc,
              });
            }
          }
          if (this.getRequestStatus === 1 && step1Response) {
            sessionStorageUtils.setItem("isUsenamePass", true);
            sessionStorageUtils.setItem("requestID", step1Response?.requestID);
            this.setMemberId(this.$v.username.$model);
            if (
              step1Response?.successFlag &&
              step1Response?.nextStep === "SN_TRIGGER_SMS_OTP"
            ) {
              window.dataLayerPush({
                event: "attempt_login",
                "eventDetails.category": "MID - login",
                "eventDetails.label": "next - successful EB username login",
                journeyType: "FO EB login",
                appId: "FO EB login",
              });
              // Trigger SMS OTP flow (ISAM Redirect flow)
              const step2Response = await this.triggerSmsOTP();
              if (
                step2Response?.successFlag &&
                step2Response?.nextStep === "SN_VERIFY_SMS_OTP"
              ) {
                // ISAM level2 flow (Redirect to otp page)
                this.$router.push(
                  `${this.urlPrefix.loginUrl}/mobile-otp-verification`
                );
              } else if (!step2Response?.successFlag) {
                if (
                  step2Response?.errCode === ERROR_CODES.MIDERR_026 ||
                  step2Response?.errCode === ERROR_CODES.MIDERR_020
                ) {
                  this.$router.replace(
                    `${this.urlPrefix.loginUrl}/my-info?errCode=${step2Response?.errCode}&optionAllowed=true`
                  );
                } else if (step2Response?.errCode === ERROR_CODES.MIDERR_038) {
                  this.$router.replace({
                    path: `${this.urlPrefix.loginUrl}/error`,
                    query: { errCode: step2Response?.errCode },
                  });
                } else if (this.getData?.errCode === ERROR_CODES.MIDERR_001) {
                  this.isCredentialInvalid = true;
                } else if (this.getData?.errCode === ERROR_CODES.MIDERR_015) {
                  const errDesc = util.getUiErrorByCode(this.getData?.errCode);
                  this.showAlert({
                    type: "error",
                    message: errDesc,
                  });
                }
              }
            } else if (
              step1Response?.successFlag &&
              step1Response?.nextStep === "SN_TRIGGER_EMAIL_OTP"
            ) {
              window.dataLayerPush({
                event: "attempt_login",
                "eventDetails.category": "MID - login",
                "eventDetails.label": "next - successful EB username login",
                journeyType: "FO EB login",
                appId: "FO EB login",
              });
              // Trigger EMAIL OTP flow (ISAM Redirect flow)
              const step2Response = await this.triggerEmailOTP();
              if (
                step2Response?.successFlag &&
                step2Response?.nextStep === "SN_VERIFY_EMAIL_OTP"
              ) {
                // ISAM level2 flow (Redirect to otp page)
                this.$router.push(
                  `${this.urlPrefix.loginUrl}/email-otp-verification`
                );
              } else if (!step2Response?.successFlag) {
                if (
                  step2Response?.errCode === ERROR_CODES.MIDERR_026 ||
                  step2Response?.errCode === ERROR_CODES.MIDERR_020
                ) {
                  this.$router.replace(
                    `${this.urlPrefix.loginUrl}/my-info?errCode=${step2Response?.errCode}&optionAllowed=true`
                  );
                } else if (step2Response?.errCode === ERROR_CODES.MIDERR_038) {
                  this.$router.replace({
                    path: `${this.urlPrefix.loginUrl}/error`,
                    query: { errCode: step2Response?.errCode },
                  });
                } else if (this.getData?.errCode === ERROR_CODES.MIDERR_001) {
                  this.isCredentialInvalid = true;
                } else if (this.getData?.errCode === ERROR_CODES.MIDERR_015) {
                  const errDesc = util.getUiErrorByCode(this.getData?.errCode);
                  this.showAlert({
                    type: "error",
                    message: errDesc,
                  });
                }
              }
            } else if (
              step1Response?.successFlag &&
              step1Response?.nextStep === "SN_VIEW_PROFILE"
            ) {
              // default flow load user profile
              sessionStorageUtils.setItem("loggedIn", true);
              if (
                sessionStorage.getItem("redirectedFromViewSetting") === "true"
              ) {
                sessionStorage.removeItem("redirectedFromViewSetting");
                this.$router.push(`${this.urlPrefix.loginUrl}/device-info`);
              } else {
                this.$router.push(`${this.urlPrefix.loginUrl}/view-profile`);
              }
            } else if (
              step1Response?.successFlag &&
              step1Response?.nextStep === "" &&
              step1Response?.responseParam?.login === "success"
            ) {
              window.dataLayerPush({
                event: "attempt_login",
                "eventDetails.category": "MID - login",
                "eventDetails.label": "next - successful EB username login",
                journeyType: "FO EB login",
                appId: "FO EB login",
              });
              const redirectUrl =
                step1Response?.responseParam &&
                step1Response?.responseParam?.redirectUrl;
              sessionStorageUtils.setItem("loggedIn", true);
              this.$__handleIsamResponse(redirectUrl);
            }
            // if (step1Response?.successFlag && this.$v.username.$model) {
            //   this.setGreatId(this.$v.username.$model);
            // }
          } else {
            //
          }
        }
      } else if (!this.$v.$invalid && this.isDesktopChannel) {
        // To get public key for password encryption
        await this.getRandomPublicKeyForEncryption(sessionStorageUtils.getItem("requestID"));
        const publicKeyData = this.getPublicKey;
        if (publicKeyData) {
          const publicKey = publicKeyData?.publicKey;
          //const random = publicKeyData?.random;
          const arr = publicKeyData?.random.split(":signature:");
          console.log("arr : " + arr);
          const random = arr[0];
          const signature = arr[1];
          console.log("random : " + random);
          console.log("signature : " + signature);
          //const encryptPwd = HSM.RsaEncrypt(
          //publicKey,
          //this.$v?.password?.$model,
          //random
          //);
          let encryptPwd = e2eejslib.EncryptSHA256Password(
            publicKey,
            this.$v?.password?.$model,
            random
          );
          console.log("encryptPwd : " + encryptPwd);
          encryptPwd = encryptPwd + "," + signature;
          console.log("encryptPwd : " + encryptPwd);
          
          const step1Response = await this.loginFlow(
            this.loginPayload(encryptPwd)
          );
          if (this.getRequestStatus === 2) {
            this.setMemberId(this.$v.username.$model);
            if (this.getData?.errCode === ERROR_CODES.MIDERR_007) {
              this.$router.push("/error/non-policy-holder");
            } else if (this.getData?.errCode === ERROR_CODES.MIDERR_020) {
              // this.$router.replace({
              //   path: `${this.urlPrefix.loginUrl}/error`,
              //   query: { errCode: this.getData?.errCode },
              // });
              this.$router.replace(
                `${this.urlPrefix.loginUrl}/my-info?errCode=${this.getData?.errCode}&optionAllowed=true`
              );
            } else if (this.getData?.errCode === ERROR_CODES.MIDERR_038) {
              this.$router.replace({
                path: `${this.urlPrefix.loginUrl}/error`,
                query: { errCode: this.getData?.errCode },
              });
            } else if (this.getData?.errCode === ERROR_CODES.MIDERR_001) {
              this.isCredentialInvalid = true;
            } else if (this.getData?.errCode === ERROR_CODES.MIDERR_015) {
              const errDesc = util.getUiErrorByCode(this.getData?.errCode);
              this.showAlert({
                type: "error",
                message: errDesc,
              });
            }
          }
          if (this.getRequestStatus === 1 && step1Response) {
            sessionStorageUtils.setItem("isUsenamePass", true);
            sessionStorageUtils.setItem("requestID", step1Response?.requestID);
            this.setMemberId(this.$v.username.$model);
            if (
              step1Response?.successFlag &&
              step1Response?.nextStep === "SN_TRIGGER_SMS_OTP"
            ) {
              window.dataLayerPush({
                event: "attempt_login",
                "eventDetails.category": "MID - login",
                "eventDetails.label": "next - successful EB username login",
                journeyType: "MO EB login",
                appId: "MO EB login",
              });
              // Trigger SMS OTP flow (ISAM Redirect flow)
              const step2Response = await this.triggerSmsOTP();
              if (
                step2Response?.successFlag &&
                step2Response?.nextStep === "SN_VERIFY_SMS_OTP"
              ) {
                // ISAM level2 flow (Redirect to otp page)
                this.$router.push(
                  `${this.urlPrefix.loginUrl}/mobile-otp-verification`
                );
              } else if (!step2Response?.successFlag) {
                if (
                  step2Response?.errCode === ERROR_CODES.MIDERR_026 ||
                  step2Response?.errCode === ERROR_CODES.MIDERR_020
                ) {
                  this.$router.replace(
                    `${this.urlPrefix.loginUrl}/my-info?errCode=${step2Response?.errCode}&optionAllowed=true`
                  );
                } else if (step2Response?.errCode === ERROR_CODES.MIDERR_038) {
                  this.$router.replace({
                    path: `${this.urlPrefix.loginUrl}/error`,
                    query: { errCode: step2Response?.errCode },
                  });
                } else if (this.getData?.errCode === ERROR_CODES.MIDERR_001) {
                  this.isCredentialInvalid = true;
                } else if (this.getData?.errCode === ERROR_CODES.MIDERR_015) {
                  const errDesc = util.getUiErrorByCode(this.getData?.errCode);
                  this.showAlert({
                    type: "error",
                    message: errDesc,
                  });
                }
              }
            } else if (
              step1Response?.successFlag &&
              step1Response?.nextStep === "SN_TRIGGER_EMAIL_OTP"
            ) {
              window.dataLayerPush({
                event: "attempt_login",
                "eventDetails.category": "MID - login",
                "eventDetails.label": "next - successful EB username login",
                journeyType: "MO EB login",
                appId: "MO EB login",
              });
              // Trigger EMAIL OTP flow (ISAM Redirect flow)
              const step2Response = await this.triggerEmailOTP();
              if (
                step2Response?.successFlag &&
                step2Response?.nextStep === "SN_VERIFY_EMAIL_OTP"
              ) {
                // ISAM level2 flow (Redirect to otp page)
                this.$router.push(
                  `${this.urlPrefix.loginUrl}/email-otp-verification`
                );
              } else if (!step2Response?.successFlag) {
                if (
                  step2Response?.errCode === ERROR_CODES.MIDERR_026 ||
                  step2Response?.errCode === ERROR_CODES.MIDERR_020
                ) {
                  this.$router.replace(
                    `${this.urlPrefix.loginUrl}/my-info?errCode=${step2Response?.errCode}&optionAllowed=true`
                  );
                } else if (step2Response?.errCode === ERROR_CODES.MIDERR_038) {
                  this.$router.replace({
                    path: `${this.urlPrefix.loginUrl}/error`,
                    query: { errCode: step2Response?.errCode },
                  });
                } else if (this.getData?.errCode === ERROR_CODES.MIDERR_001) {
                  this.isCredentialInvalid = true;
                } else if (this.getData?.errCode === ERROR_CODES.MIDERR_015) {
                  const errDesc = util.getUiErrorByCode(this.getData?.errCode);
                  this.showAlert({
                    type: "error",
                    message: errDesc,
                  });
                }
              }
            } else if (
              step1Response?.successFlag &&
              step1Response?.nextStep === "CP_RESET_PASSWORD"
            ) {
              // default flow load user profile
              sessionStorageUtils.setItem("loggedIn", true);
              sessionStorageUtils.setItem(
                "signInEmail",
                this.$v.username.$model
              );
              clearMemberIdRequestID();
              this.$router.push(`${this.urlPrefix.loginUrl}/change-password`);
            } else if (
              step1Response?.successFlag &&
              step1Response?.nextStep === "" &&
              step1Response?.responseParam?.login === "success"
            ) {
              window.dataLayerPush({
                event: "attempt_login",
                "eventDetails.category": "MID - login",
                "eventDetails.label": "next - successful EB username login",
                journeyType: "MO EB login",
                appId: "MO EB login",
              });
              const redirectUrl =
                step1Response?.responseParam &&
                step1Response?.responseParam?.redirectUrl;
              sessionStorageUtils.setItem("loggedIn", true);
              this.$__handleIsamResponse(redirectUrl);
            }
            // if (step1Response?.successFlag && this.$v.username.$model) {
            //   this.setGreatId(this.$v.username.$model);
            // }
          } else {
            //
          }
        }
      }
    },

    async triggerSmsOTP(isResend = false) {
      return await this.loginFlow(this.triggerSmsOtpPayload(isResend));
    },

    triggerSmsOtpPayload(isResend = false) {
      const requestID = sessionStorageUtils.getItem("requestID");
      return {
        requestID: requestID,
        flowName: "signIn",
        stepName: "SN_TRIGGER_SMS_OTP",
        requestParam: {
          memberId: this.getMemberId, // Cater later to handle isam request where we need to pass member Id
          isResend: isResend,
        },
      };
    },

    async triggerEmailOTP(isResend = false) {
      return await this.loginFlow(this.triggerEmailOtpPayload(isResend));
    },

    triggerEmailOtpPayload(isResend = false) {
      const requestID = sessionStorageUtils.getItem("requestID");
      return {
        requestID: requestID,
        flowName: "signIn",
        stepName: "SN_TRIGGER_EMAIL_OTP",
        requestParam: {
          memberId: this.getMemberId, // Cater later to handle isam request where we need to pass member Id
          isResend: isResend,
        },
      };
    },

    loginPayload(encryptPwd) {
      console.log("In loginPayload encryptPwd : " + encryptPwd);
      const requestID = this.isamRequestID
        ? this.isamRequestID
        : sessionStorageUtils.getItem("requestID");
      return {
        requestID: requestID,
        flowName: "signIn",
        stepName: "SN_VERIFY_MEMBERID_AND_PASSWORD",
        requestParam: {
          country: this.defaultCountry,
          memberId: this.$v.username.$model.toLowerCase(),
          password: encryptPwd,
        },
      };
    },
    fidoLoginPayload(stateId) {
      const requestID = this.isamRequestID
        ? this.isamRequestID
        : sessionStorageUtils.getItem("requestID");
      return {
        requestID: requestID,
        flowName: "signIn",
        stepName: "SN_VERIFY_MEMBERID_AND_PASSWORD",
        stateId: stateId,
        loginType: "FIDO",
        requestParam: {
          country: this.defaultCountry,
          memberId: "",
          password: "",
        },
      };
    },
    openContactUs() {
      this.isContactUsShow = true;
    }
  },
  computed: {
    ...mapGetters("user", [
      "isFetching",
      "getPublicKey",
      "getData",
      "getRequestStatus",
      "getMemberId",
      "getExistingMemberId",
    ]),
    isDisabledUserName() {
      return this.isamMemberId !== "" ? true : false;
    }
  },
  validations: {
    username: {
      required,
      customEmailValidator,
    },
    password: {
      required,
      customValidator,
    },
  },
};
</script>
